import { defineMessage } from 'services/localization';

export const messages = {
    inputPlaceholder: defineMessage('enter_or_copy_emails_here'),
    addButtonText: defineMessage('add'),
    invalidEmailsDescription: defineMessage('the_following_emails_ar_id_and_can_not_be_added'),
    invalidEmailsText: defineMessage('and_count_more'),
    emailsBelongsToATeamMember: defineMessage('the_following_emails_al_ist_in_the_organisation'),
};
